module.exports = __webpack_public_path__ + "static/media/blackalo30.b6cb7ce9.png";